export default "__VITE_ASSET__CGcFpJkq__ 640w, __VITE_ASSET__kBpRpc6O__ 1024w, __VITE_ASSET__0no3c_XU__ 1200w";